import { ConfigProvider, Progress } from 'antd';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { UploadExpandProps } from '../context/type';

const ProcessBar = ({
  failItem,
  processingList,
  remainingCount,
}: {
  failItem: UploadExpandProps['failItem'];
  processingList: UploadExpandProps['processingList'];
  remainingCount: UploadExpandProps['remainingCount'];
}) => {
  const { t } = useTranslation('Vindoc');

  return (
    <div>
      <span className="text-base">
        {`${t('Processed')} ${remainingCount}/${processingList.size} ${t('file(s)')}, ${
          remainingCount - (failItem?.length || 0)
        } ${t('success')}, ${failItem?.length || 0} ${t('failed')} `}
      </span>
      <ConfigProvider theme={{ token: { colorSuccess: '#39c2d7' } }}>
        <Progress percent={((remainingCount / processingList.size) * 100) | 0} />
      </ConfigProvider>
    </div>
  );
};
export default memo(ProcessBar);
